// extracted by mini-css-extract-plugin
module.exports = {"arrow":"SampleSwiper_arrow__lxLLO","nextArrow":"SampleSwiper_nextArrow__382LV","prevArrow":"SampleSwiper_prevArrow__1_TYw","img_container":"SampleSwiper_img_container__2VgEK"};